
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 53 53"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"data-name":"Path 1","d":"M24 1h28v28","fill":"none","stroke":"#05c3dd","stroke-linecap":"round","stroke-miterlimit":"10","stroke-width":"2","stroke-dasharray":"0 4.667"}}),_c('g',{attrs:{"data-name":"Group 2"}},[_c('path',{attrs:{"data-name":"Rectangle 1","d":"M24 5h24v24a24 24 0 01-24 24A24 24 0 010 29 24 24 0 0124 5z","fill":"#11365f"}}),_c('g',{attrs:{"data-name":"Group 1","fill":"none","stroke":"#fff","stroke-linecap":"round","stroke-miterlimit":"10","stroke-width":"2"}},[_c('path',{attrs:{"data-name":"Line 1","d":"M24 18v22"}}),_c('path',{attrs:{"data-name":"Line 2","d":"M13 29h22"}})])])])
          )
        }
      }
    